<template>
  <div class="auth__colimages">
    <div class="auth__images">
      <div class="auth__images--slider">
        <div class="auth__images--slider-item">
          <img src="@/assets/images/auth/box-slider/health.jpeg" alt="" />
        </div>
        <div class="auth__images--slider-item">
          <img src="@/assets/images/auth/box-slider/dating.png" alt="" />
        </div>
        <div class="auth__images--slider-item">
          <img src="@/assets/images/auth/box-slider/business.png" alt="" />
        </div>
      </div>
      <div class="auth__images--content">
        <div class="auth__images--content-item">
          <div class="auth__images--content-head">
            <span class="icon"
              ><img src="@/assets/images/auth/icon/business.svg" alt=""
            /></span>
            <span class="title">{{ $t("auth.business") }}</span>
          </div>
          <p class="auth__images--content-description">
            {{ $t("auth.business_login_desc") }}
          </p>
        </div>
        <div class="auth__images--content-item">
          <div class="auth__images--content-head">
            <span class="icon"
              ><img src="@/assets/images/auth/icon/dating.svg" alt=""
            /></span>
            <span class="title">{{ $t("auth.acquaintance") }}</span>
          </div>
          <p class="auth__images--content-description">
            {{ $t("auth.acquaintance_login_desc") }}
          </p>
        </div>
        <div class="auth__images--content-item">
          <div class="auth__images--content-head">
            <span class="icon"
              ><img src="@/assets/images/auth/icon/health.svg" alt=""
            /></span>
            <span class="title">{{ $t("auth.health") }}</span>
          </div>
          <p class="auth__images--content-description">
            {{ $t("auth.health_login_desc") }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AuthSlider",
  data: () => ({
    imageUrl: process.env.VUE_APP_IMAGE_URL,
  }),
};
</script>
